import { Container, Box, Flex, useMantineTheme, Drawer } from "@mantine/core";
import { useState } from "react";
import { useMediaQuery } from "@mantine/hooks";
import { Link, useLocation } from "react-router-dom";

import { IconMenu2 } from "@tabler/icons-react";
import { useExtraHeaderStyles } from "../styles/components/ExtraHeaderStyles";
const ExtraHeader = () => {
    const { classes } = useExtraHeaderStyles();
    const [toggle, setToggle] = useState(false);
    const mediumScreen = useMediaQuery("(min-width: 1160px)");

    // Function to toggle the menu visibility
    const toggleMenu = () => {
        setToggle(!toggle);
    };
    const theme = useMantineTheme();
    const location = useLocation();

    return (
        <Box className={classes.root}>
            <Container size={"xxl"} fluid>
                <Flex className={classes.group}>
                    <Link to={"/"}>
                        <img
                            src="/assets/cagtulogo1.png"
                            className={classes.cagtulogo}
                            alt="cagtu-logo"
                        />
                    </Link>
                    {mediumScreen ? (
                        <div className={classes.headerItems}>
                            <ul style={{ margin: 0, padding: 0 }}>
                                <Link to={"/"}>
                                    {" "}
                                    <li
                                        style={{
                                            margin: 0,
                                            color:
                                                location.pathname === "/"
                                                    ? theme.colors.primary[0]
                                                    : "black",
                                        }}
                                    >
                                        Home
                                    </li>
                                </Link>
                                <Link to={"/about-us"}>
                                    <li
                                        style={{
                                            margin: 0,
                                            color:
                                                location.pathname ===
                                                "/about-us"
                                                    ? theme.colors.primary[0]
                                                    : "black",
                                        }}
                                    >
                                        About Us
                                    </li>
                                </Link>
                                <Link to={"/products"}>
                                    <li
                                        style={{
                                            margin: 0,
                                            color:
                                                location.pathname ===
                                                "/products"
                                                    ? theme.colors.primary[0]
                                                    : "black",
                                        }}
                                    >
                                        Products
                                    </li>
                                </Link>
                                <Link to={"/careers"}>
                                    <li
                                        style={{
                                            margin: 0,
                                            color:
                                                location.pathname === "/careers"
                                                    ? theme.colors.primary[0]
                                                    : "black",
                                        }}
                                    >
                                        Careers
                                    </li>
                                </Link>{" "}
                                <Link to={"/contact-us"}>
                                    <li
                                        style={{
                                            margin: 0,
                                            color:
                                                location.pathname ===
                                                "/contact-us"
                                                    ? theme.colors.primary[0]
                                                    : "black",
                                        }}
                                    >
                                        Contact Us
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    ) : (
                        <div className={classes.mobileMenu}>
                            <IconMenu2
                                size={24}
                                onClick={toggleMenu}
                                color="black"
                            />
                            {toggle && (
                                <Drawer
                                    opened={toggle}
                                    size={"45%"}
                                    position="top"
                                    overlayProps={{ opacity: 0.5, blur: 4 }}
                                    onClose={toggleMenu}
                                    title={
                                        <img
                                            src="/assets/cagtulogo1.png"
                                            alt="cagtu-logo"
                                            width={140}
                                        />
                                    }
                                >
                                    <Flex>
                                        <ul style={{ listStyle: "none" }}>
                                            <Link to={"/"}>
                                                {" "}
                                                <li
                                                    style={{
                                                        color:
                                                            location.pathname ===
                                                            "/"
                                                                ? theme.colors
                                                                      .primary[0]
                                                                : "black",
                                                    }}
                                                >
                                                    Home
                                                </li>
                                            </Link>
                                            <Link to={"/about-us"}>
                                                <li
                                                    style={{
                                                        color:
                                                            location.pathname ===
                                                            "/about-us"
                                                                ? theme.colors
                                                                      .primary[0]
                                                                : "black",
                                                    }}
                                                >
                                                    About Us
                                                </li>
                                            </Link>
                                            <Link to={"/products"}>
                                                <li
                                                    style={{
                                                        color:
                                                            location.pathname ===
                                                            "/products"
                                                                ? theme.colors
                                                                      .primary[0]
                                                                : "black",
                                                    }}
                                                >
                                                    Products
                                                </li>
                                            </Link>
                                            <Link to={"/careers"}>
                                                <li
                                                    style={{
                                                        color:
                                                            location.pathname ===
                                                            "/careers"
                                                                ? theme.colors
                                                                      .primary[0]
                                                                : "black",
                                                    }}
                                                >
                                                    Careers
                                                </li>
                                            </Link>{" "}
                                            <Link to={"/contact-us"}>
                                                <li
                                                    style={{
                                                        color:
                                                            location.pathname ===
                                                            "/contact-us"
                                                                ? theme.colors
                                                                      .primary[0]
                                                                : "black",
                                                    }}
                                                >
                                                    Contact Us
                                                </li>
                                            </Link>
                                        </ul>
                                    </Flex>
                                </Drawer>
                            )}
                        </div>
                    )}
                </Flex>
            </Container>
        </Box>
    );
};
export default ExtraHeader;
